module.exports = __webpack_public_path__ + "img/community-bag.e9ced578.svg";